// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@conklin/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentWishListsStyles } from "@conklin/Overrides/Widgets/Common/RecentWishLists";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.wishListCardGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};

recentWishListsStyles.wishListCard = {
    container: {
        css: css`
            grid-template-columns: minmax(0, 1fr) minmax(0, 317px) minmax(0, 135px) minmax(0, 165px);
        `,
    },
};

recentWishListsStyles.cardListStyles = {
    gridContainer: {
        gap: 40,
        offsetCss: css`
            &&& {
                width: 100%;
                margin: 0;
            }
        `,
        css: css`
            &&& {
                padding-right: 0;
                padding-left: 0;
            }
        `,
    },
};

recentWishListsStyles.cardContainer = {
    cardDivider: {
        css: css`
            width: 100%;
            margin: 0;
            border-bottom: 1px solid ${color("common.border")};
        `,
    },
    gridItem: {
        width: 12,
        css: css`
            padding: 12px 0;
        `,
    },
};

recentWishListsStyles.noWishListsGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};

recentWishListsStyles.noWishListsText = {
    ...dataTableStyles.noResultsText,
};

recentWishListsStyles.titleTypographyStyles = {
    wrapper: {
        css: css`
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 12px;
            margin-bottom: 13px;
        `,
    },
};
